import { money, tierClass } from "../api.js";
import { jobLabel, ladderLabel, moneyRange, tip, tierLabel } from "../ux.js";

export function renderPitch(pack) {
  const pitch = pack.pitch || {};
  const roll = pack.product_rollup || {};
  const top = (pack.leads || []).slice(0, 8);
  const rows = top
    .map((L, i) => {
      const rec = L.recommendation || {};
      const lab = ladderLabel(rec.ladder_focus);
      const t = tierLabel(L.tier);
      return `<tr>
        <td>${i + 1}</td>
        <td><span class="badge ${tierClass(L.tier)}" title="${t.tip}">${t.short}</span></td>
        <td>
          <strong>${L.address || ""}</strong><br/>
          <span class="muted">${L.city || ""} ${L.zip || ""}</span>
        </td>
        <td>${rec.primary_brand_name || "—"}<br/><span class="muted">${lab.short} · ${rec.job_label || jobLabel(rec.job_type)}</span></td>
        <td class="muted">${moneyRange(rec.rev_low, rec.rev_high)}</td>
        <td><strong>${money(rec.expected_rev_mid)}</strong></td>
      </tr>`;
    })
    .join("");

  return `
    <h1>Pitch kit</h1>
    <p class="sub">Share this with a dealer partner — top homes and suggested packages</p>

    ${tip(
      "How to use this page",
      "Copy the email draft into your CRM or inbox. Walk the partner through the top 5–8 homes: " +
        "priority (Hot/Solid), what to sell, and package range. Remind them: site measure before any formal quote."
    )}

    <div class="kpis compact-kpis">
      <div class="kpi"><b>${pack.lead_count || 0}</b><span>Leads in pack</span></div>
      <div class="kpi"><b>${money(roll.expected_pipeline_rev)}</b><span>Likely pack revenue</span></div>
      <div class="kpi"><b>${money(roll.avg_package_mid)}</b><span>Typical ticket</span></div>
    </div>

    <div class="panel">
      <h2>Offer snapshot</h2>
      <p><strong>${pitch.offer || pack.offer || "Outdoor living lead pack"}</strong></p>
      <p class="muted">For: ${pitch.buyer || pack.buyer || "patio shade contractors"}</p>
    </div>

    <div class="panel">
      <h2>Top homes to walk through</h2>
      <div class="table-wrap">
        <table class="data">
          <thead>
            <tr>
              <th>#</th>
              <th>Priority</th>
              <th>Home</th>
              <th>What to sell</th>
              <th>Package range</th>
              <th>Likely $</th>
            </tr>
          </thead>
          <tbody>${rows || `<tr><td colspan="6" class="muted">No leads yet</td></tr>`}</tbody>
        </table>
      </div>
    </div>

    <div class="panel">
      <h2>Email you can send</h2>
      <p class="muted small">Edit names/dates before sending.</p>
      <div class="pre copy-block">${escapeHtml(pitch.email || "Generate a pack (export-web) to fill this email draft.")}</div>
    </div>

    ${
      pitch.markdown
        ? `<div class="panel">
      <h2>Extra notes</h2>
      <div class="pre">${escapeHtml(pitch.markdown)}</div>
    </div>`
        : ""
    }

    <div class="toolbar">
      <a class="btn primary" href="#/pack">Open full lead list</a>
      <a class="btn" href="#/review">Street View review</a>
    </div>
  `;
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}
